import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from '@/hooks/use-toast';
import { influencerRepository } from '../repositories/influencer.repository';
import { influencerKeys } from '../services/influencer.keys';
import type { InfluencerRow } from '../types/influencer.types';

export function useDeleteInfluencers() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (ids: string[]) => {
      await influencerRepository.deleteMany(ids);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: influencerKeys.all });
      toast({
        title: 'Success',
        description: 'Influencer(s) deleted successfully',
      });
    },
    onError: () => {
      toast({
        title: 'Error',
        description: 'Failed to delete influencer(s)',
        variant: 'destructive',
      });
    },
  });
}

export function useUpdateInfluencer() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, updates }: { id: string; updates: Partial<InfluencerRow> }) => {
      return await influencerRepository.update(id, updates);
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: influencerKeys.detail(data.id) });
      queryClient.invalidateQueries({ queryKey: influencerKeys.lists() });
      toast({
        title: 'Success',
        description: 'Influencer updated successfully',
      });
    },
    onError: () => {
      toast({
        title: 'Error',
        description: 'Failed to update influencer',
        variant: 'destructive',
      });
    },
  });
}
